import YakFetch from './utils/yak_fetch';
import ServiceBase from './service_base';

export default class AccountDeleter extends ServiceBase {

  static async delete() {
    const endpoint = `${process.env.REACT_APP_SERVICE_ENDPOINT_BASE}/api/account/delete_account`
    const response = await YakFetch.fetch(endpoint, 'DELETE');
    await AccountDeleter._abortIfUnsuccessful(response);
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/services/account_deleter.js